import { Box, CircularProgress } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route } from "react-router-dom";
import { AuthRoutes } from "./auth";
import { login } from "./auth/actions";
import { CollectiblesRoutes } from "./collectibles";
import { accessTokenCookieName, refreshTokenCookieName } from "./common/config";
import { ContentRoutes } from "./content";
import { FinancialProfileRoutes } from "./financial-profile";
import { HighlightsRoutes } from "./highlights";
import { LearningRoutes } from "./learning";
import { LearningPathRoutes } from "./learning-path";
import { ParticipantRoutes } from "./participant";
import { TasksRoutes } from "./participant/pages/participantTasksPage";
import { ProfileRoutes } from "./participantProfile";
import { asyncGetProfile } from "./participantProfile/actions/profileActions";
import { PoliciesRoutes } from "./policies/routes";
import { QuickWinsRoutes } from "./quick-wins";
import { NewParticipantLayout } from "./shared/components/new-participant-layout";
import { useSearchParams } from "./shared/hooks/useSearchParams";
import { loginCookies } from "./shared/utils/auth";
import type { RootState } from "./store";
import { StripeRoutes } from "./stripe";
import { ToolsRoutes } from "./tools";

export const AppRoutes = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const params = useSearchParams();

  const accessToken =
    params.get("accessToken") || loginCookies.get(accessTokenCookieName);
  const refreshToken =
    params.get("refreshToken") || loginCookies.get(refreshTokenCookieName);

  const authId = useSelector<RootState, string>(
    (state) => state.auth.login.authId
  );

  useEffect(() => {
    const hasToken = accessToken && refreshToken;

    if (hasToken && authId) {
      dispatch(asyncGetProfile(authId));
      setLoading(false);
      return;
    }

    if (hasToken && !authId) {
      setLoading(true);
      dispatch(
        login({
          username: accessToken,
          password: refreshToken,
          isTokenProvided: true,
        })
      );
      return;
    }

    setLoading(false);
  }, [dispatch, accessToken, refreshToken, authId]);

  if (loading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100vw"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <AuthRoutes />
      <StripeRoutes />
      <PoliciesRoutes />
      <LearningPathRoutes />
      <Route path="/participant/:path?">
        <NewParticipantLayout>
          <ParticipantRoutes />
          <ProfileRoutes />
          <ContentRoutes />
          <LearningRoutes />
          <TasksRoutes />
          <FinancialProfileRoutes />
          <QuickWinsRoutes />
          <HighlightsRoutes />
          <CollectiblesRoutes />
          <ToolsRoutes />
        </NewParticipantLayout>
      </Route>
    </>
  );
};
